export const ENTITY = 'feature-flags';
